import React, { useRef, useLayoutEffect, useCallback } from 'react';
import pencilIcon from '../../../../../../shared/assets/images/lotto-assistant/pencil-outlined.svg';
import classes from './StakeInput.module.scss';

const StakeInput = ({
  stakeInput,
  currencyPrefix = 'R',
  onInputChange,
  onBlur,
}) => {
  const inputRef = useRef(null);
  const selectionRef = useRef(null);

  useLayoutEffect(() => {
    const input = inputRef.current;
    if (!input || selectionRef.current === null) return;
    const max = input.value.length;
    const start = Math.min(selectionRef.current.start, max);
    const end = Math.min(selectionRef.current.end, max);
    input.setSelectionRange(start, end);
  }, [stakeInput]);

  const handleChange = useCallback(
    (e) => {
      selectionRef.current = {
        start: e.target.selectionStart ?? e.target.value.length,
        end: e.target.selectionEnd ?? e.target.value.length,
      };
      onInputChange(e.target.value);
    },
    [onInputChange]
  );

  return (
    <label className={classes.Container}>
      <span className={classes.Label}>STAKE</span>
      <span className={classes.InputWrapper}>
        <span className={classes.Prefix}>{currencyPrefix}</span>
        <input
          ref={inputRef}
          type="text"
          value={stakeInput}
          onChange={handleChange}
          onBlur={onBlur}
          autoComplete="off"
          inputMode="decimal"
          pattern="[0-9.]{0,9}"
          className={classes.Input}
        />
        <img src={pencilIcon} alt="" width={20} height={20} className={classes.EditIcon} />
      </span>
    </label>
  );
};

export default StakeInput;
